export default __webpack_public_path__ + "static/media/logo-light.7fee80d9.png";